import { render, staticRenderFns } from "./ColegioSanJuan.vue?vue&type=template&id=43787c5a&scoped=true"
import script from "./ColegioSanJuan.vue?vue&type=script&lang=js"
export * from "./ColegioSanJuan.vue?vue&type=script&lang=js"
import style0 from "./ColegioSanJuan.vue?vue&type=style&index=0&id=43787c5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43787c5a",
  null
  
)

export default component.exports